/* VOLUFILINE — Video band (sections/vf-band-video.liquid)
   - Creator cards: muted loop autoplay only while each card is on screen (IntersectionObserver);
     src is set on first view (preload="none"); posters only with reduced motion / Save-Data.
     Paused while the story viewer is open or the tab is hidden.
   - Tap a card: vf-landing.js opens the shared story viewer via data-vf-story-open="<index>".
     If no viewer opened (none on the page / not bound), the card plays inline with sound.
   - How-to link: opens a <dialog> with assets/vf-howto.mp4 (src set on open, paused on close). */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save = navigator.connection && navigator.connection.saveData;
  var auto = !reduce && !save && 'IntersectionObserver' in window;

  function track(what) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'volufiline_click', what: what }); } catch (e) {}
  }
  function storyOpen() { return html.classList.contains('vf-story-open'); }
  function play(v) { if (!v.getAttribute('src')) v.src = v.getAttribute('data-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function bind(root) {
    if (!root || root.__vfBv) return;
    root.__vfBv = true;
    var vids = Array.prototype.slice.call(root.querySelectorAll('[data-vf-bv-vid]'));
    var visible = new Set();
    var inline = null; /* the card playing with sound, if any */

    function sync() {
      vids.forEach(function (v) {
        var btn = v.parentNode;
        if (btn === inline) return;
        if (auto && visible.has(v) && !storyOpen() && !d.hidden && !inline) play(v); else v.pause();
      });
    }

    if (auto) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        sync();
      }, { threshold: 0.55 });
      vids.forEach(function (v) { io.observe(v); });
      new MutationObserver(sync).observe(html, { attributes: true, attributeFilter: ['class'] });
      d.addEventListener('visibilitychange', sync);
    }

    function stopInline() {
      if (!inline) return;
      var v = inline.querySelector('video');
      v.muted = true; v.pause();
      inline.classList.remove('is-sound', 'is-paused');
      inline = null;
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-vf-bv-card]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.querySelector('video');
        if (inline === btn) {
          if (v.paused) { play(v); btn.classList.remove('is-paused'); } else { v.pause(); btn.classList.add('is-paused'); }
          return;
        }
        /* give vf-landing.js a tick to open the shared story viewer */
        setTimeout(function () {
          if (storyOpen()) { vids.forEach(function (x) { x.pause(); }); return; }
          stopInline();
          inline = btn;
          vids.forEach(function (x) { if (x !== v) x.pause(); });
          v.muted = false; v.currentTime = 0;
          btn.classList.add('is-sound');
          play(v);
          track('creator_inline_' + (btn.getAttribute('data-vf-story-open') || ''));
        }, 80);
      });
    });
    /* leaving the band ends inline sound playback */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting && inline) { stopInline(); sync(); }
      }, { threshold: 0 }).observe(root);
    }

    /* how-to modal */
    var modal = root.querySelector('[data-vf-bv-modal]');
    var opener = root.querySelector('[data-vf-bv-howto]');
    if (modal && opener) {
      var hv = modal.querySelector('[data-vf-bv-howto-vid]');
      opener.addEventListener('click', function () {
        if (typeof modal.showModal !== 'function') { window.open(hv.getAttribute('data-src'), '_blank'); return; }
        vids.forEach(function (x) { x.pause(); });
        modal.showModal();
        if (!hv.getAttribute('src')) hv.src = hv.getAttribute('data-src');
        var p = hv.play(); if (p && p.catch) p.catch(function () {});
      });
      modal.querySelector('[data-vf-bv-close]').addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
      modal.addEventListener('close', function () { hv.pause(); sync(); if (opener.focus) opener.focus({ preventScroll: true }); });
    }
  }

  function init() { Array.prototype.forEach.call(d.querySelectorAll('[data-vf-bv]'), bind); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { bind(e.target.querySelector('[data-vf-bv]')); });
})();
